import { StreamHandler } from "./stream.handler";
import { SubscribePrizeDropPrizes, UpdatePrizeDropPrizes } from "@/types";
import type { PrizeDropPrizesSchema } from "@/types";
import { useAppStore } from "@/stores";
import { recomputePrizeDrops } from "@/stores/derive";

/**
 * `prize_drop_prizes` — the prize-drop-specific volatile stream (`left_to_win`
 * drop counts + `max_prizes_per_player`). Feeds `prizeDropPrizesById`; the
 * assembled `prizeDrops` view is re-derived on change.
 */
export class PrizeDropPrizesHandler extends StreamHandler<PrizeDropPrizesSchema[]> {
  protected readonly subscribeType = SubscribePrizeDropPrizes;
  protected readonly updateType = UpdatePrizeDropPrizes;

  protected isBusy(): boolean {
    const s = useAppStore.getState().prizeDropPrizesStream;
    return s.subscribed || s.loading;
  }
  protected setLoading(loading: boolean): void {
    useAppStore.getState().setPrizeDropPrizesLoading(loading);
  }
  protected setSubscribed(subscribed: boolean): void {
    useAppStore.getState().setPrizeDropPrizesSubscribed(subscribed);
  }
  protected clear(): void {
    useAppStore.getState().clearPrizeDropPrizes();
    recomputePrizeDrops();
  }
  protected apply(data: PrizeDropPrizesSchema[]): void {
    useAppStore.getState().setPrizeDropPrizes(data);
    recomputePrizeDrops();
  }
}

export const prizeDropPrizesHandler = new PrizeDropPrizesHandler();
